module.exports = __webpack_public_path__ + "static/media/dustbin-red.3f1402a4.svg";